export const isAuthenticated = () => {
    // Replace this with your actual authentication logic
    return localStorage.getItem("token") !== null;
  };